import { render } from "./NotificacionesList.vue?vue&type=template&id=2e9d37a5&scoped=true"
import script from "./NotificacionesList.vue?vue&type=script&lang=js"
export * from "./NotificacionesList.vue?vue&type=script&lang=js"

import "./NotificacionesList.vue?vue&type=style&index=0&id=2e9d37a5&scoped=true&lang=css"

import exportComponent from "/home/runner/work/jeanInformatico-management-system/jeanInformatico-management-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2e9d37a5"]])

export default __exports__